import { OrderHistoryWashmenIcon } from 'assets/icons/app';
import OptionItem from 'components/molecules/OptionItem';
import { useActiveOrders } from 'pages/orderDetails/hooks/useActiveOrders';
import * as React from 'react';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledTitle = styled.span<{ $colorPriority?: number }>`
  color: ${({ theme, $colorPriority }) =>
    $colorPriority === 0
      ? theme.components.orderHistory.activeColor
      : $colorPriority === 1
        ? theme.components.orderHistory.pendingColor
        : $colorPriority === 2
          ? theme.components.orderHistory.failedColor
          : undefined};
`;

const StyledOptionItem = styled(OptionItem)`
  margin-top: 48px;
  margin-bottom: 8px;
  border: unset;
  padding: unset;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0.4px;
`;

const StyledOrderHistoryWashmenIcon = styled(OrderHistoryWashmenIcon)<{ colorPriority?: number }>`
  > circle {
    ${({ theme, colorPriority }) => ({
      fill:
        colorPriority === 0
          ? theme.components.orderHistory.activeColor
          : colorPriority === 1
            ? theme.components.orderHistory.pendingColor
            : colorPriority === 2
              ? theme.components.orderHistory.failedColor
              : undefined,
    })};
  }
  > path {
    ${({ theme, colorPriority }) => ({
      stroke:
        colorPriority === 0
          ? theme.components.orderHistory.activeColor
          : colorPriority === 1
            ? theme.components.orderHistory.pendingColor
            : colorPriority === 2
              ? theme.components.orderHistory.failedColor
              : undefined,
    })};
  }
`;

const OrderHistoryButtonRow = () => {
  const navigate = useNavigate();
  const { activeOrderInfo } = useActiveOrders();
  const onPress = useCallback(() => {
    navigate('/orders');
  }, []);
  return (
    <StyledOptionItem
      title={<StyledTitle $colorPriority={activeOrderInfo?.color}>{activeOrderInfo?.title} </StyledTitle>}
      startIcon={<StyledOrderHistoryWashmenIcon colorPriority={activeOrderInfo?.color} />}
      hasRightArrowOnly
      isEditable
      actionType="open"
      onClick={onPress}
    />
  );
};

export default OrderHistoryButtonRow;
